<div class="center-content">

    <div class="table-header">
        <!-- Nom de la table -->
        <div class="medium-border-arma-color table-title-fit-content-no-margin table-certificate-title">
            {{ HTML_TableName | translate }}
        </div>

        <!-- Séparation element debut / fin -->
        <span class="filler"></span>

        <!-- Selection contrat -->
        <ng-container *ngIf="HTML_currentCertificateStyle == HTML_CstStyle.byOrder">
            <div class="select-order-list">
                <mat-form-field>
                    <mat-label>{{'Décorticage' | translate}}</mat-label>
                    <mat-select (selectionChange)="searchCertificateByOrder($event.value)">
                        <mat-option *ngFor="let order of HTML_arrayAnalysis" [value]="order.OrderCode">
                            {{order.OrderCode}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container>

        <!-- Séparation element debut / fin -->
        <span class="filler"></span>

        <!-- Btn dnwload all -->
        <button mat-raised-button
            class="fit-h-centered-btn"
            [disabled]="HTML_TableDataSource.data.length == 0 || mDisableBTN"
            (click)="downloadAllCertificats()">
            {{ 'Télécharger tout' | translate }}
        </button>
    </div>

    <div *ngIf="HTML_showLoadingCircle" class="table-header">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <div class="table-header">

        <!-- Input DN -->
        <ng-container *ngIf="HTML_currentCertificateStyle == HTML_CstStyle.byDN">
            <div class="small-border-arma-color table-header-input-centered">
                <span> {{'Bon de livraison' | translate}} : <input [(ngModel)]="HTML_Search" type="text"> <button
                        (click)="searchCertificateByDN(HTML_Search)">{{'Rechercher' | translate}}</button></span>
            </div>
            <div class="small-border-arma-color table-header-input-centered">
                <span>{{'Entrer le numéro du BL et cliquez sur \"Rechercher\". Le numéro du BL ressemble à \"1706001\"' | translate}}</span>
            </div>
        </ng-container>

        <!-- Input Etiq -->
        <ng-container *ngIf="HTML_currentCertificateStyle == HTML_CstStyle.byTag">
            <div class="small-border-arma-color table-header-input-centered">
                <span> {{'Code étiquette'| translate}} : <input [(ngModel)]="HTML_Search" type="text"> <button
                        (click)="searchCertificateByTag(HTML_Search)">{{'Rechercher' | translate}}</button> </span>
            </div>
            <div class="small-border-arma-color table-header-input-centered">
                <span>{{'Entrer le numéro de l\'étiquette et cliquez sur \"Rechercher\". Le numéro resemble à \"B000123456E\"' | translate}} </span>
            </div>
        </ng-container>
    </div>

    <table style="width: 100%" class="mat-elevation-z8 medium-border-arma-color" mat-table #tableCommande
        [dataSource]="HTML_TableDataSource">

        <ng-container matColumnDef="File name">
            <th mat-header-cell *matHeaderCellDef> {{'Nom du fichier' | translate}} </th>
            <td mat-cell *matCellDef="let element">{{element.DOC_NAME}}</td>
        </ng-container>

        <ng-container matColumnDef="Action">
            <th style="min-width: 200px;" mat-header-cell *matHeaderCellDef>{{'Action' | translate}}</th>
            <td style="min-width: 200px;" mat-cell *matCellDef="let element">
                <button mat-stroked-button [disabled]="mDisableBTN" (click)="showCertificate(element, false)">{{'Consulter' | translate}}</button>
                <button mat-stroked-button [disabled]="mDisableBTN" (click)="showCertificate(element, true)">{{'Télécharger' | translate}}</button>
            </td>
        </ng-container>

        <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="HTML_TableHeader; sticky: true;">
        </tr>
        <tr mat-row *matRowDef="let row; columns: HTML_TableHeader;"></tr>


    </table>

    <mat-spinner *ngIf="HTML_showLoadingCircle"></mat-spinner>
</div>
